import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import moment from "moment";
import { request, sleep } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { getFullNameUserHtml } from "@/js/user/user.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { orderStatus, getOrderStatusInt, getOrderStatusLabel, orderTypes, expeditionMethods, IMPORTER } from "@/js/lists.ts";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    MailTemplateModal: MailTemplateModal,
    MailTemplateForm: MailTemplateForm
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    order: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      URL: URL,
      drawer: false,
      drawerWidth: "45%",
      isLoadingFiles: false,
      documents: [],
      isSuccessfulSending: {},
      hasFailedSending: false,
      failedCustomMails: {},
      emailPlaceholders: {},
      emailTemplates: [],
      isSyncing: false,
      isNeedingSync: false,
      isDeletingTemplate: false,
      templateModalShown: false,
      editableTemplate: {},
      panels: [],
      openedPanel: 0,
      form: {
        deliveryDate: null,
        emailTemplates: []
      },
      isSendNotificationMails: true,
      preventNotifyCustomer: false,
      preventNotifyStaff: false,
      steps: [],
      defaultSteps: [],
      currentStep: 1,
      isUpdatingStatus: false,
      isStatelessDrawer: true,
      errorOccurred: false,
      isCopyingToClipboard: false,
      subordersTableHeaders: [{
        text: "Order",
        value: "reference",
        align: "left"
      }, {
        text: "Customer",
        value: "user",
        align: "left"
      }, {
        text: "Delivery",
        value: "deliveryAddress",
        align: "left"
      }, {
        text: "Amount",
        value: "amount",
        align: "center",
        cellCss: "text-nowrap"
      }, {
        text: "NbBottles",
        value: "quantity",
        align: "center"
      }],
      orderStatus: orderStatus,
      expeditionMethods: expeditionMethods,
      rules: formRules,
      ERROR_DATA: ERROR_DATA,
      IMPORTER: IMPORTER
    };
  },
  computed: {
    hasParentContainerNotDelivered: function hasParentContainerNotDelivered() {
      var _this$order$parentCon;
      return ((_this$order$parentCon = this.order.parentContainerOrder) === null || _this$order$parentCon === void 0 ? void 0 : _this$order$parentCon.id_order) > 0 && this.order.parentContainerOrder.status != getOrderStatusInt("DELIVERED");
    },
    isContainerOrder: function isContainerOrder() {
      var _this$order;
      return ((_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.type) === orderTypes.CONTAINER;
    },
    isContainerOrderWithAnySuborderNotInDelivery: function isContainerOrderWithAnySuborderNotInDelivery() {
      var _this$order$container;
      var forbiddenStatus = [orderStatus.find(function (x) {
        return x.id == "VALIDATED";
      }).status, orderStatus.find(function (x) {
        return x.id == "IN_PREPARATION";
      }).status, orderStatus.find(function (x) {
        return x.id == "ADJUSTING";
      }).status];
      return this.isContainerOrder && ((_this$order$container = this.order.containerSubOrders) === null || _this$order$container === void 0 ? void 0 : _this$order$container.some(function (x) {
        return forbiddenStatus.includes(x.status);
      }));
    },
    today: function today() {
      return new Date().toISOString().substr(0, 10);
    },
    isInvalidMainForm: function isInvalidMainForm() {
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      return false;
    },
    errorsMainForm: function errorsMainForm() {
      if (this.isInvalidMainForm) {
        var errors = [];
        var nullishPredicate = function nullishPredicate(x) {
          var _x$sendTo2;
          return !x.id || !x.from || !((_x$sendTo2 = x.sendTo) !== null && _x$sendTo2 !== void 0 && _x$sendTo2.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
        };
        if (this.form.emailTemplates.some(nullishPredicate)) errors.push("At least one mail configured is still not set correctly. You should delete it, or configure it completely.");
        return errors;
      }
      return null;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    }
  },
  watch: {
    isShown: function () {
      var _isShown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(visible) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.drawer = visible;
              this.closureAttempt = 0;
              this.isUpdatingStatus = false;
              if (visible) {
                if (!this.defaultSteps.length) {
                  this.defaultSteps = _toConsumableArray(this.steps.map(function (x) {
                    return _objectSpread({}, x);
                  }));
                }
                this.initStep();
                this.fetchEmailPlaceholders();
                this.fetchEmailTemplates();
                this.fetchOrderDocuments();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isShown(_x) {
        return _isShown.apply(this, arguments);
      }
      return isShown;
    }(),
    currentStep: function currentStep(_currentStep) {
      if (this.steps.length > 0 && _currentStep === this.steps.find(function (x) {
        return x.key === "mail";
      }).id) {
        this.drawerWidth = "80%";
      } else {
        this.drawerWidth = "45%";
      }
    }
  },
  updated: function updated() {
    this.closureAttempt++;
  },
  methods: {
    changePanel: function changePanel() {
      var _this2 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this2.openedPanel && _this2.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context2.sent;
              if (isConfirmed) {
                _this3.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isSyncing = true;
              _context3.next = 3;
              return _this4.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this4.form.emailTemplates[_this4.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this4.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this4.changeTemplate(current);
              }
              _this4.isSyncing = false;
              _this4.isNeedingSync = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this5 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this5.templateModalShown = false;
      });
    },
    newTemplate: function newTemplate() {
      var _this6 = this;
      this.$nextTick(function () {
        return _this6.templateModalShown = true;
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this7;
              _context4.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this7.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this7.isNeedingSync = true;else _this7.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context5.sent;
              if (!isConfirmed) {
                _context5.next = 14;
                break;
              }
              _this8.isDeletingTemplate = true;
              _this = _this8;
              _context5.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to delete this template.");
                handleErrorData(_this, errorData);
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context5.next = 10;
              return _this8.fetchEmailTemplates();
            case 10:
              rest = _this8.form.emailTemplates.filter(function (x) {
                return x.id === templateId;
              });
              _this8.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this8.editableTemplate = {};
              _this8.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this9;
              _context6.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to fetch email templates.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context6.sent;
              _this9.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return request("/v1/mail/placeholders?orderId=".concat(_this10.order.id_order), "get", null, true, "api");
            case 2:
              response = _context7.sent;
              _this10.emailPlaceholders = response.data;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    newEmail: function newEmail() {
      var _this11 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this11.form.emailTemplates.length - 1;
        _this11.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    close: function close() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isConfirmed = true;
              if (!(_this12.order.expedition_method && !_this12.hasFailedSending)) {
                _context8.next = 5;
                break;
              }
              _context8.next = 4;
              return _this12.$refs.confirm.open("Cancel", "Are you sure you want to cancel the status edition ?");
            case 4:
              isConfirmed = _context8.sent;
            case 5:
              if (isConfirmed) {
                _this12.currentStep = 1;
                _this12.steps = _toConsumableArray(_this12.defaultSteps.map(function (x) {
                  return _objectSpread({}, x);
                }));
                _this12.isStatelessDrawer = false;
                _this12.drawer = false;
                _this12.$emit("close", true);
                _this12.isStatelessDrawer = true;
              }
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    validateMain: function validateMain() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var isConfirmed, _this, _loop, i;
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this13.$refs.confirm.open("Order delivered", "Are you sure that the order has been delivered at this date ?");
            case 2:
              isConfirmed = _context12.sent;
              if (!isConfirmed) {
                _context12.next = 16;
                break;
              }
              _this = _this13;
              _this13.isUpdatingStatus = true;
              _context12.next = 8;
              return _this13.updateStateOrder(_this13.order, {
                send_mails: _this13.isSendNotificationMails,
                preventNotifyCustomer: _this13.preventNotifyCustomer,
                preventNotifyStaff: _this13.preventNotifyStaff,
                deliveryDate: _this13.form.deliveryDate
              }).catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to edit the status of the order.", true);
                handleErrorData(_this, errorData);
                _this.isUpdatingStatus = false;
                throw e;
              });
            case 8:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      template = _this13.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this13;
                      _context11.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                          while (1) switch (_context9.prev = _context9.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context9.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context9.stop();
                          }
                        }, _callee9);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                            while (1) switch (_context10.prev = _context10.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context10.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context10.stop();
                            }
                          }, _callee10);
                        }));
                        return function (_x2) {
                          return _ref2.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context11.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 10:
              if (!(i < _this13.form.emailTemplates.length)) {
                _context12.next = 15;
                break;
              }
              return _context12.delegateYield(_loop(i), "t0", 12);
            case 12:
              i++;
              _context12.next = 10;
              break;
            case 15:
              _this13.$emit("validate", true, function () {
                if (!_this13.hasFailedSending) _this13.$emit("close", true);
                _this13.isUpdatingStatus = false;
                _this13.$toasted.show("Order delivered.", {
                  type: "success"
                });
              });
            case 16:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    updateStateOrder: function updateStateOrder(order, body) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", request("/v1/order/" + order.id_order + "/state/" + orderStatus.find(function (os) {
                return os.id === "DELIVERED";
              }).status, "put", body, true, "api"));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    emptyDocuments: function emptyDocuments() {
      this.documents = [];
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.isLoadingFiles = true;
              _this = _this14;
              _context14.next = 4;
              return request("/v1/orders/" + _this14.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context14.sent;
              _this14.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this14.isLoadingFiles = false;
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    initStep: function initStep() {
      var stepCount = 1;
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "delivery-date",
        title: "Set delivery date",
        inf: "Please select the date that the order has been delivered"
      }]);
      stepCount++;
      if (this.order.type == orderTypes.CONTAINER) {
        this.steps = [].concat(_toConsumableArray(this.steps), [{
          id: stepCount,
          key: "container-suborders",
          title: "Container suborders",
          inf: "Suborders delivery reminder"
        }]);
        stepCount++;
      }
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "mail",
        title: "Send custom e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: stepCount + 1,
        key: "synthesis",
        title: "Synthesis"
      }]);
      this.form.deliveryDate = new Date().toISOString().substr(0, 10);
      this.currentStep = 1;
    },
    confirmDeliveryDate: function confirmDeliveryDate(slot) {
      var _this15 = this;
      if (!slot) {
        this.errorOccurred = true;
      } else {
        this.errorOccurred = false;
        this.confirmStep();
        setTimeout(function () {
          return _this15.changePanel();
        }, 200);
      }
    },
    orderDetails: function orderDetails(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this16 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this16.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    getFullNameUserHtml: getFullNameUserHtml,
    getOrderStatusLabel: getOrderStatusLabel,
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency
  }
};